import React, { useState } from "react";

export const YouTubeVideoInput = ({ setYouTubeUrl, initialValue = "" }) => {
  const [videoUrl, setVideoUrl] = useState(initialValue);
  const [videoId, setVideoId] = useState(() => {
    if (!initialValue) return "";
    const regex =
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\s*[^\/\n\s]+\/|(?:v|e(?:mbed)?)\/|\S*?[\?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = initialValue.match(regex);
    return match ? match[1] : "";
  });

  // Function to extract the YouTube video ID from a URL
  const extractVideoId = (url) => {
    const regex =
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\s*[^\/\n\s]+\/|(?:v|e(?:mbed)?)\/|\S*?[\?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  // Handle changes in the input field
  const handleInputChange = (event) => {
    const url = event.target.value;
    setVideoUrl(url);
    const id = extractVideoId(url);
    if (id) {
      setVideoId(id);
      setYouTubeUrl(url);
    } else {
      setVideoId("");
    }
  };

  return (
    <div className="">
      {/* ADD LABEL  */}
      <label htmlFor="round" className="label">
        Youtube Video (Optional)
      </label>
      <input
        type="text"
        value={videoUrl}
        onChange={handleInputChange}
        placeholder="Enter YouTube video URL"
        className="w-full p-2 bg-flyers-charcoal text-white border border-flyers-dark-gray rounded mb-4 focus:border-flyers-orange focus:outline-none placeholder-flyers-mid-gray"
      />
      {videoId && (
        <iframe
          width="560"
          height="315"
          src={`https://www.youtube.com/embed/${videoId}`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="YouTube video player"
          className="w-full aspect-video"
        ></iframe>
      )}
    </div>
  );
};
